// extracted by mini-css-extract-plugin
module.exports = {"banner_con":"style_banner_con__2htfn","banner_title":"style_banner_title__jB-t1","banner_desc":"style_banner_desc__1K6yl"};